<div>
    <h1 mat-dialog-title>Message to {{delegateName}}</h1>
    <mat-dialog-content>
        <mat-form [formGroup]="messageForm">
            <mat-form-field required class="flex-full">
                <mat-label for="messageSubject">Subject</mat-label>
                <input matInput id="messageSubject" type="text" title="message subject" formControlName="messageSubject">
            </mat-form-field>
            <br />
            <mat-form-field required class="flex-full">
                <mat-label for="messageText">Message</mat-label>
                <textarea matInput #messageText title="Message text to send" formControlName="messageText"></textarea>
            </mat-form-field>
        </mat-form>
        @if ( showSentMessage ) {
        <mutara-alert statusType="info" description="Message sent"></mutara-alert>
        }
        @if ( showRequiredMessage ) {
        <mutara-alert statusType="invalid" description="All fields are required"></mutara-alert>
        }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-flat-button mat-dialog-close color="accent">Cancel</button>
        <button mat-flat-button (click)="sendMessage('email')" color="accent">Send Email</button>
        <button mat-flat-button (click)="sendMessage('sms')" color="accent">Send Text</button>
    </mat-dialog-actions>
</div>